import { Table } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react";
import "../../../../common/styles/table.css";
import QuizOverviewTableRow from "./QuizOverviewTableRow";
import { useGetClassroomOverview } from "../../../../hooks/quiz/useGetClassroomOverview";
import { ITEMS_PER_PAGE } from "../../../../constant/constant";
import TablePagination from "../pagination/TablePagination";
import TableSkeleton from "../../common/TableSkeleton";
import TableError from "../../common/TableError";
import RefreshButtonTable from "../../../common/RefreshButtonTable";

const QuizOverviewTable = () => {
  const { loading, error, classrooms, meta, getClassroomOverview } =
    useGetClassroomOverview();
  const [currentPage, setCurrentPage] = useState(1);

  const fetchClassrooms = useCallback(
    (page) => {
      getClassroomOverview({
        page,
        per_page: ITEMS_PER_PAGE,
      });
    },
    [],
  );

  useEffect(() => {
    fetchClassrooms(currentPage);
  }, [currentPage]);

  const handleRefresh = () => {
    fetchClassrooms(currentPage);
  };

  // Show skeleton only on initial load
  if (loading && classrooms === undefined) {
    return <TableSkeleton rows={ITEMS_PER_PAGE} columns={6} />;
  }

  if (error || classrooms === null) {
    return (
      <TableError
        error={error}
        handleRefresh={handleRefresh}
        loading={loading}
      />
    );
  }

  const totalPages = meta?.last_page || 1;
  const hasClassrooms = classrooms && classrooms.length > 0;

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />
      </div>

      {!hasClassrooms ? (
        <div className="alert alert-info mt-3" role="alert">
          No classrooms found.
        </div>
      ) : (
        <div className="custom-table-container mt-3">
          <div className="custom-table-wrapper">
            <Table hover className="custom-table">
              <thead className="custom-table-head">
                <tr>
                  <th>Classroom Name</th>
                  <th className="text-center">Students</th>
                  <th className="text-center">Quiz Limit</th>
                  <th className="text-center">Extended</th>
                  <th className="text-center">Exhausted Students</th>
                </tr>
              </thead>
              <tbody>
                {classrooms.map((classroom) => (
                  <QuizOverviewTableRow
                    key={classroom.classroom_id}
                    classroom={classroom}
                    disabled={loading}
                  />
                ))}
              </tbody>
            </Table>
          </div>

          <TablePagination
            totalPage={totalPages}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            disabled={loading}
          />
        </div>
      )}
    </div>
  );
};

export default QuizOverviewTable;
